import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"
export const Filters = props => {
  const {
    item,
    setItem,
    options,
  } = props
  const monthSeleceted =props.selectedMonth
  return (
      <Fragment>
        <Card>
          <CardBody>
            <CardTitle className="mb-4"></CardTitle>

            <div className="row mb-4">
              <Col lg={4}>
                <Label htmlFor="horizontal-firstname-Input">Month</Label>
                <Input
                    type="month"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    onChange={e => {
                      props.setSelectedMonth(e.target.value)
                    }}
                    value={monthSeleceted}
                />
              </Col>
              <Col lg={4}>
                <Label htmlFor="horizontal-firstname-Input">Type</Label>
                <Select
                    options={options}
                    maxMenuHeight={150}
                    classNamePrefix="select2-selection"
                    onChange={(selectedOption) => {
                      setItem(selectedOption.value);
                    }}
                    value={item.label}
                />
              </Col>
              <Col lg={4} className="d-flex flex-column justify-content-end">
                <Button type="submit" color="primary" className="w-md" onClick={() => {
                  props.call()
                }}>
                  Submit
                </Button>
              </Col>
            </div>
          </CardBody>
        </Card>
      </Fragment>
  )
}
